export default __webpack_public_path__ + "static/media/Plissee 22 vertikal.98208036.jpg";